import { Card, Grid, Typography } from '@mui/material';
import { BarChart } from '@mui/x-charts/BarChart';
import { axisClasses } from '@mui/x-charts/ChartsAxis';
import { JobStatistics } from '../../Types/Statistics';

interface KaziJobsBarChartChartProps {
  chartKey: string;
  title: string;
  dataset?: JobStatistics;
  xAxisLabel?: string;
  height?: number;
  onItemClick?: () => void;
}

export const KaziJobsBarChart = ({
  chartKey,
  title,
  dataset,
  xAxisLabel,
  height = 400,
  onItemClick,
}: KaziJobsBarChartChartProps) => {
  const transformedDataset = dataset
    ? [
        {
          label: '',
          totalJobs: dataset.totalJobs,
          completedJobs: dataset.completedJobs,
          inProgressJobs: dataset.inProgressJobs,
        },
      ]
    : [];

  return (
    <Card
      sx={{
        borderRadius: '12px',
        padding: '24px',
        margin: '24px',
      }}
    >
      <Grid container gap={'20px'} key={chartKey} width={'100%'}>
        <Typography variant="lora-headline-small">{title}</Typography>
        {dataset !== undefined && dataset !== null && (
          <BarChart
            dataset={transformedDataset}
            xAxis={[{ scaleType: 'band', dataKey: 'label', label: xAxisLabel }]}
            yAxis={[{ label: 'Jobs' }]}
            series={[
              {
                dataKey: 'totalJobs',
                label: `Total (${dataset.totalJobs})`,
                valueFormatter: v => `${v}`,
              },
              {
                dataKey: 'completedJobs',
                label: `Completed (${dataset.completedJobs})`,
                valueFormatter: v => `${v}`,
              },
              {
                dataKey: 'inProgressJobs',
                label: `In Progress (${dataset.inProgressJobs})`,
                valueFormatter: v => `${v}`,
              },
            ]}
            height={height}
            sx={{
              [`.${axisClasses.left} .${axisClasses.label}`]: {
                transform: 'translate(-10px, 0)',
              },
            }}
            onItemClick={onItemClick}
          />
        )}
      </Grid>
    </Card>
  );
};
